<template>
  <el-dialog
    :title="projectid ? '修改项目信息' : '新建项目'"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    custom-class="radius5"
    width="420px"
    :append-to-body="true"
  >
    <el-form
      ref="editProjectFormRef"
      :model="editProjectForm"
      :rules="editProjectRules"
      label-position="left"
      label-width="80px"
    >
      <el-form-item label="项目名称" prop="project_title">
        <el-input v-model="editProjectForm.project_title" ref="projectNameRef"></el-input>
      </el-form-item>
      <el-form-item label="项目描述">
        <el-input type="textarea" :rows="5" v-model="editProjectForm.remark"></el-input>
      </el-form-item>

      <el-form-item label="负责人">
        <div v-if="!projectid">
          <span class="flex align-items-center">
            <f-user-avatar :user="user" :preview="false" size="mini" role="button" />
            <!-- <img v-if="user.avatar" :src="user.avatar" alt="" class="image sm circle" />
            <img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm" />-->
            <span class="ml-xs ellipsis">{{ user.username }}</span>
          </span>
        </div>
        <div v-else class="flex align-items-center">
          <manager-pull-down
            :row-item="detail"
            class="task-status-edit-class"
            @change="handleManagerChange"
          />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex-center">
      <el-button size="small" @click="dialogShow = false">取消</el-button>
      <el-button size="small" type="primary" @click="submit">{{ projectid ? '确定' : '立即创建' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getProjectDetailApi } from "@/api/pm/projectApi";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    projectid: {
      type: Number,
      default: null,
    },
  },

  components: {
    ManagerPullDown: () => import("../task/components/ManagerPullDown"),
  },

  data() {
    return {
      editProjectForm: {
        projectid: null,
        project_title: "",
        remark: "",
        principal: null,
      },
      editProjectRules: {
        project_title: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
      },
      detail: {},
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    user() {
      return this.$store.state.userStore.user;
    },
  },
  created() {
    this.editProjectForm.principal = this.projectid ? null : this.user.uid;
    if (this.projectid) {
      this.$store.dispatch("setTeamMember", { projectid: this.projectid });
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      getProjectDetailApi({ projectid: this.projectid }).then((res) => {
        this.editProjectForm["projectid"] = res.data.projectid;
        this.editProjectForm.project_title = res.data.project_title;
        this.editProjectForm.remark = res.data.remark;
        this.editProjectForm.principal = res.data.principal;
        this.detail = Object.assign({}, res.data);
      });
    },

    submit() {
      this.$refs.editProjectFormRef.validate((flag) => {
        if (flag) {
          this.$emit("submit", this.editProjectForm);
          this.dialogShow = false;
        }
      });
    },

    handleEditProjectOpened() {
      this.$refs.projectNameRef.focus();
    },

    handleManagerChange(val) {
      this.detail.principal = val.uid;
      this.detail.principal_username = val.username;
      this.detail.principal_avatar = val.avatar;
      // console.log(val);
    },

    handleEditProjectClosed() {
      this.editProjectForm.projectid = null;
      this.editProjectForm.project_title = "";
      this.editProjectForm.remark = "";
      this.$refs.editProjectFormRef.clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
.pm-remove {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
/deep/.my-dropdown3 {
  left: 0 !important;
}
/deep/ .el-icon-user {
  display: none;
}
</style>